<script setup lang="ts">
  import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'
  import FooterSteps from "~/components/pages/Enquiry/MultiStepsForm/Steps/FooterSteps.vue";
  import { ref, computed, watch, reactive, onMounted } from 'vue'
  import useFormValidation from "~/utils/validators";
  import Input from "~/components/ui/input/Input.vue";
  import ToggleButton from "~/components/ui/toggle-button/ToggleButton.vue";
  import RadioBox from "~/components/ui/radio-box/RadioBox.vue";
  import MultipleSelect from "~/components/ui/multiple-select/MultipleSelect.vue";
  import { groupContinent, isDeepEqual, isEmpty } from '~/helper'
  import { clickOutSide as vClickOutSide } from '~/directives/newClickOutSide';
  import { useRoute } from 'vue-router'
  import { EnquiryStepEnum } from '~/enum/enquiry'
  import { getEnquiryID } from '~/helper/enquiry'
  import { DESKTOP } from "~/constant/common";
  import { useEnquiryCaptureStore } from '~/store/pinia/enquiryCapture'
  import { useGeneralInfoStore } from '~/store/pinia/generalInfo'

  const props = defineProps({
    formData: { type: Object, default: () => {} }
  })

  const emits = defineEmits(['nextStep', 'prevStep', 'change-destination'])

  // const dataLengthTrip = ref(TRAVELLER_TRIP_LENGTH)
  const error = ref('')
  const errorsLengthOfTrip = ref(false)
  const errorsMonth = ref(false)
  const disableSubmitButton = ref(false)
  const dataDestination = ref<any>([])
  const errorsDestination = ref(false)
  const popupMonthYear = ref(false)
  const btnArrowClass = 'px-6 py-6 bg-gray-100-brand br-6'
  const popularDestinations = ref<any[]>([])
  const enquiryCaptureStore = useEnquiryCaptureStore()
  const route = useRoute()
  const generalStore = useGeneralInfoStore()

  const dateObj = reactive({
    year: new Date().getFullYear(),
    month: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
    minYear: new Date().getFullYear(),
    maxYear: null,
    monthSelected: {
      index: new Date().getMonth(),
      name: ''
    }
  })

  const attrs = ref([
    {
      dates: new Date()
    }
  ])

  const popover = ref({
    visibility: 'click'
  });

  const dataStep = reactive({
    lengthOfTrip: null as number | null,
    exactDate: true,
    ddMMMYYYY: null as Date | null,
    mmmYYYY: null as string | null,
    haveFlights: 'no' as 'yes' | 'no',
    destination: [] as any[],
    dateSelected: '',
  })

  const radioList = [
    {
      label: "No, I haven’t booked flights",
      value: 'no',
    },
    {
      label: 'Yes, I already have flights',
      value: 'yes',
    },
  ]

  const {
    validateNameField,
    validateEmailField,
    validatePhoneNumberField,
    errors,
  } = useFormValidation()

  const arrayStepEnquiry = computed(() => enquiryCaptureStore.arrayStep)
  const stepOld = computed(() => enquiryCaptureStore.stepsData)
  const stepBefore = computed( () => {
    if(stepOld.value &&
       stepOld.value[(route.path).toString()] &&
       stepOld.value[(route.path).toString()][EnquiryStepEnum.YourTrip])
    return stepOld.value[(route.path).toString()][EnquiryStepEnum.YourTrip]
    return {}
  })
  const indexCurrentStep = computed(() => arrayStepEnquiry.value.indexOf(EnquiryStepEnum.YourTrip) + 1)

  const nextStep = async () => {
    errorsDestination.value = dataStep.destination.length === 0
    // errorsLengthOfTrip.value = Object.keys(dataStep.lengthOfTrip).length === 0
    errorsLengthOfTrip.value = dataStep.lengthOfTrip! <= 0
    errorsMonth.value = dataStep.exactDate ? !dataStep.ddMMMYYYY : !dataStep.mmmYYYY

    if(!errorsDestination.value && !errorsLengthOfTrip.value && !errorsMonth.value) {
      let dest =  []
      disableSubmitButton.value = true
      dest = dataStep.destination.map(function(item) {
        return {
          city_id: item.id,
          country_id: item.country_code,
          region_id: item.level === 'region' ? item.id : 0,
          name: item.name
        }
      })

      let date = ''
      if(dataStep.exactDate) {
        date = dataStep?.ddMMMYYYY?.getDate() + '-' + (dataStep?.ddMMMYYYY!.getMonth() + 1) + '-' + dataStep?.ddMMMYYYY?.getFullYear()
      } else {
        // date = dataStep.mmmYYYY.replaceAll(" ","-")
        date = (dateObj.monthSelected.index + 1) + "-" + dateObj.year
      }

      dataStep.dateSelected = date

      // let length_of_trip = ''
      //
      // if (route.name === 'enquiry-submit-trip' && !dataStep.lengthOfTrip.name.includes('+')) {
      //   length_of_trip = dataStep.lengthOfTrip.value
      // } else {
      //   length_of_trip = dataStep.lengthOfTrip.value + "+"
      // }

      let payload = {
        path: (route.path).toString(),
        step: EnquiryStepEnum.YourTrip,
        [EnquiryStepEnum.YourTrip]: {
          destinations: dest,
          exact_date: dataStep.exactDate ? 1 : 0,
          has_flight_ticket: dataStep.exactDate ? ((dataStep.haveFlights === 'yes') ? 1 : 0) : undefined,
          arrival_month: !dataStep.exactDate ? date : undefined,
          arrival_date: dataStep.exactDate ? date : undefined,
          // length_of_trip: (route.name === 'enquiry-submit-trip') ? length_of_trip : dataStep.lengthOfTrip.label
          length_of_trip: dataStep.lengthOfTrip
        }
      }

      const stepEdit = isDeepEqual(stepBefore.value,dataStep)

      if(!stepEdit) {
        disableSubmitButton.value = true
        const step = await enquiryCaptureStore.submitEnquiryCapture({ payload, dataStep: {...toRaw(dataStep), destination: [...toRaw(dataStep.destination)]} })
        disableSubmitButton.value = false
        if(step?.status === 200) {
          debounceAmplitudeScriptTracking('View Enquiry (step 3)', {
            enquiry_id: getEnquiryID(route.path),
          })
          error.value = ''
          emits('nextStep')
        } else {
          error.value = step?.message || ''
          throw new Error(`submit enquiry step ${EnquiryStepEnum.YourTrip} error:`, {
            cause: {
              data: step,
              payload,
            }
          })
        }
      } else if(!error.value) {
        emits('nextStep')
      }
      disableSubmitButton.value = false
    }
  }

  watch(dataStep, (val) => {
    if (val.destination.length !== 0) errorsDestination.value = false
    if ((!val.exactDate && val.mmmYYYY) || (val.exactDate && val.ddMMMYYYY)) errorsMonth.value = false
    // if (!isEmpty(val.lengthOfTrip)) errorsLengthOfTrip.value = false
    if (val.lengthOfTrip! > 0) errorsLengthOfTrip.value = false
  })

  const handleTrackExactDate = () => {
    debounceAmplitudeScriptTracking("Switch Exact Travel Date")
  }

  const openSelectMonthYear = () => {
    popupMonthYear.value = true
  }

  const prevYear = () => {
    if(canBack.value) return
    dateObj.year = dateObj.year - 1
  }

  const nextYear = () => {
    if(canNext.value) return
    dateObj.year = dateObj.year + 1
  }

  const selectMonth = (month: string, index: number) => {
    dateObj.monthSelected.index = index
    dateObj.monthSelected.name = month

    dataStep.mmmYYYY = `${month} ${dateObj.year}`

    popupMonthYear.value = false
  }

  const canBack = computed(() => {
    if(!dateObj.minYear) return false
    return dateObj.year <= dateObj.minYear
  })

  const canNext = computed(() => {
    if(!dateObj.maxYear) return false
    return dateObj.year >= dateObj.maxYear
  })

  const pastMonth = computed(() => {
    if(canBack.value) {
      const currentDate = new Date()
      const prevDate = new Date()
      prevDate.setDate(0)
      return ((currentDate.getFullYear() >= prevDate.getFullYear()) && (currentDate.getMonth() >= prevDate.getMonth())) ? prevDate.getMonth() : -1
    }
    return -1
  })

  const closePopupMonthYear = () => {
    popupMonthYear.value = false
  }

  const windowWidth = computed(() => generalStore.generalData.windowWidth)
  const isDesktop = computed(() => windowWidth.value > DESKTOP)

  watch(()=> enquiryCaptureStore.enquiryOptionData, (value)=> {
    if(!isEmpty(value)) {
      dataDestination.value = value?.destinations
      popularDestinations.value = route.name !== 'enquiry-submit-ld' ? groupContinent(value!.popular_destination) : []
      if(route.name === 'enquiry-submit-trip' || route.name === 'trip-plan') {
        if(!dataStep?.destination.length) {
          mapDestination(value)
        }
        // mapLengthTrip(value)
        if(!dataStep.lengthOfTrip) {
          dataStep.lengthOfTrip = value!.trip_durations.find((v: any)=> v.same_as_trip)!.value
        }
      } else if(!dataStep?.destination.length && (route.name === 'enquiry-submit-destination')) {
        dataStep.destination = enquiryCaptureStore.galleryData.listDestination
      }
    }
  })

  watch(()=> enquiryCaptureStore.galleryData.listDestination, (value)=> {
    if(!value) return
    if(!dataStep?.destination.length && route.name === 'enquiry-submit-destination') {
      dataStep.destination = value
    }
  })
  watch(()=> dataStep.destination,
    (value)=> {
      if(!value || route.name !== 'enquiry-submit-destination') return
      emits('change-destination', value)
    },
    {deep: true}
  )
  const mapDestination = (value: any) => {
    dataStep.destination = value?.countries ? Object.values(value.countries) : []
  }

  // const mapLengthTrip = (value: any) => {
  //   dataLengthTrip.value = value.trip_durations ? value.trip_durations.map(({
  //                                                                 label: name,
  //                                                                 same_as_trip,
  //                                                                 ...rest
  //                                                               }) => ({
  //         name: same_as_trip ? `${name} (same as selected trip)` : name,
  //         ...rest
  //       })) : []
  // }

  onMounted(() => {
    // const storeSS = JSON.parse(sessionStorage.getItem(keyLocalStorage.enquiry))
    // const data = (storeSS && storeSS[route.path]) ? storeSS[route.path]?.your_trip : {}
    const data = stepBefore.value

    const enquiryOption = enquiryCaptureStore.enquiryOptionData

    if(enquiryOption?.destinations) {
      dataDestination.value = enquiryOption.destinations
    }

    if(enquiryOption?.popular_destination) {
      popularDestinations.value = groupContinent(enquiryOption.popular_destination)
    }

    if(data?.destination) {
      dataStep.destination = [ ...data?.destination ]
    } else if(route.name === 'enquiry-submit-trip' || route.name === 'trip-plan') {
      mapDestination(enquiryOption)
      // mapLengthTrip(enquiryOption)
    } else if((route.name === 'enquiry-submit-destination')) {
      dataStep.destination = enquiryCaptureStore.galleryData.listDestination
    }

    dataStep.lengthOfTrip = data?.lengthOfTrip || null
    if(!dataStep.lengthOfTrip && (route.name === 'enquiry-submit-trip' || route.name === 'trip-plan')) {
      dataStep.lengthOfTrip = enquiryOption!.trip_durations ? enquiryOption!.trip_durations.find((v: any)=> v.same_as_trip)!.value : null
    }
    if(data?.exactDate !== undefined) {
      dataStep.exactDate = data?.exactDate
    }

    if(dataStep.exactDate) {
      dataStep.ddMMMYYYY = data?.ddMMMYYYY ? new Date(data?.ddMMMYYYY) : null
      dataStep.haveFlights = data?.haveFlights || dataStep.haveFlights
    } else {
      const date = data?.dateSelected ? data?.dateSelected.split('-') : null
      if(date) {
        dateObj.monthSelected.index = date[0] - 1
        dateObj.monthSelected.name = dateObj.month[dateObj.monthSelected.index]
        dateObj.year = date[1]
        dataStep.mmmYYYY = `${dateObj.monthSelected.name} ${dateObj?.year}`
      }
    }
    if(route.name === 'enquiry-submit-ld') {
      popularDestinations.value = []
    }
  })
</script>

<template>
  <div>
    <div class='px-24 mb-px-16 overflow-auto' :style='isDesktop || formData.isUIPopup ? `height: ${formData.heightForm}px` : ""'>
      <div :class='formData.labelClass?.stepsLabel'>Step {{ indexCurrentStep }} of 5</div>
      <div :class='formData.labelClass?.titleClass'>Your Trip</div>
      <div :class='[formData.labelClass?.subTitleClass, formData.labelClass?.divider]'>Tell us about your plans.</div>
      <div class="pt-16">
        <div class="relative">
          <div class="content-form">
              <label :class="formData.labelClass?.cssLabelField" ref="destinationRef">Destination</label>
              <div class='mb-12 relative'>
                <MultipleSelect
                placeHolderText="Destination"
                :options="dataDestination"
                :popularDestinations="popularDestinations"
                v-model="dataStep.destination"
                ></MultipleSelect>
                <div class="error-message" v-if="errorsDestination">This is a required field.</div>
              </div>
            <label :class="formData.labelClass?.cssLabelField"  ref='lengthOfTripRef'>Length of trip (days)</label>
            <div class='mb-12'>
<!--              <SelectBox
              placeholder="Length of Trip"
              :noPlaceholder='true'
              no-background
              :options="dataLengthTrip"
              v-model:optionSelected="dataStep.lengthOfTrip"
              :hasBgColor='true'
              ></SelectBox>-->
              <Input
                type="number"
                placeholder="Length of Trip"
                name="length_of_trip"
                id="length_of_trip"
                :minNumber='0'
                v-model="dataStep.lengthOfTrip"
              ></Input>
              <div class="error-message" v-if="errorsLengthOfTrip">This is a required field.</div>
            </div>
            <div class='flex justify-between items-center'>
              <label :class="formData.labelClass?.cssLabelField" ref="monthOfTravelRef">When do you want to travel?</label>
              <div class='flex justify-between items-center'>
                <label class="fs-14 lh-20 fw-500 mr-8">Exact Date</label>
                <ToggleButton v-model:checked="dataStep.exactDate"
                              @click="handleTrackExactDate"
                              id='enquiry-form-toggle-switch-exact-travel-date'
                              :checkInit='dataStep.exactDate'/>
              </div>
            </div>
            <div class='mb-12'>
              <template v-if='dataStep.exactDate'>
                <VDatePicker v-model="dataStep.ddMMMYYYY"
                             locale="en"
                             :min-date="new Date(Date.now())"
                             :masks="{ input: 'DD, MMM YYYY' }"
                             :attributes="attrs"
                             :popover="popover">
                  <template #default="{ inputValue, inputEvents }">
                    <div class='relative'>
                      <input :value='inputValue' v-on="inputEvents" readonly placeholder='DD, MMM YYYY'
                             class="dj-input h-40 pt-12 pb-12 pl-35 pr-35 br-6 bd-1 bd-gray-medium fs-14 lh-17 wp-100 outline-0" />
                      <div class='absolute left-16' style='top:13px; width: 14px; height: 14px;' >
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <g clip-path="url(#clip0_1983_10777)">
                            <path d="M11.375 2.1875H2.625C2.38338 2.1875 2.1875 2.38338 2.1875 2.625V11.375C2.1875 11.6166 2.38338 11.8125 2.625 11.8125H11.375C11.6166 11.8125 11.8125 11.6166 11.8125 11.375V2.625C11.8125 2.38338 11.6166 2.1875 11.375 2.1875Z" stroke="#545454" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9.625 1.3125V3.0625" stroke="#545454" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M4.375 1.3125V3.0625" stroke="#545454" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M2.1875 4.8125H11.8125" stroke="#545454" stroke-linecap="round" stroke-linejoin="round"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_1983_10777">
                              <rect width="14" height="14" fill="white"/>
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </div>
                  </template>
                </VDatePicker>
                <div class="error-message" v-if="errorsMonth">This is a required field.</div>
                <div class='gray-700-brand fs-14 fw-500 lh-20 mt-8 mb-12'>
                  Sharing your travel dates helps us estimate an accurate price, whilst also planning the best experiences.
                </div>
                <label :class="formData.labelClass?.cssLabelField">Have you already booked your flights?</label>
                <div class='mb-12'>
                  <RadioBox
                  v-for="(item, index) in radioList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                  name="flights"
                  class="mb-8"
                  :isChecked="dataStep.haveFlights === item.value"
                  v-model:change="dataStep.haveFlights"
                  />
                </div>
              </template>
              <template v-else>
                <div class='relative' v-click-out-side="() => closePopupMonthYear()">
                  <div @click='openSelectMonthYear'>
                    <Input
                    type="text"
                    placeholder="MMM YYYY"
                    name="month_year"
                    id="month_year"
                    v-model="dataStep.mmmYYYY"
                    :readonly='true'
                    extraClass='pl-35'
                    >
                    <template #loading>
                      <div class='absolute left-16' style='top:13px; width: 14px; height: 14px;' >
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <g clip-path="url(#clip0_1983_10777)">
                            <path d="M11.375 2.1875H2.625C2.38338 2.1875 2.1875 2.38338 2.1875 2.625V11.375C2.1875 11.6166 2.38338 11.8125 2.625 11.8125H11.375C11.6166 11.8125 11.8125 11.6166 11.8125 11.375V2.625C11.8125 2.38338 11.6166 2.1875 11.375 2.1875Z" stroke="#545454" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9.625 1.3125V3.0625" stroke="#545454" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M4.375 1.3125V3.0625" stroke="#545454" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M2.1875 4.8125H11.8125" stroke="#545454" stroke-linecap="round" stroke-linejoin="round"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_1983_10777">
                              <rect width="14" height="14" fill="white"/>
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </template>
                  </Input>
                  </div>
                  <div v-if='popupMonthYear'
                       style='width: 250px; transform: translateY(-100%)'
                       class='absolute left-0 top-0 pt-10'>
                    <div class='month-year-popup bg-white br-10 pa-10'>
                      <div class="flex justify-between items-center">
                        <button :class="['btn-arrow',btnArrowClass,{'pointer-none disable': canBack}]" :disabled="canBack" aria-label="Previous year" @click="prevYear">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                            <path d="M8.75 11.375L4.375 7L8.75 2.625" stroke="#0A0A0A" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </button>
                        <div class='fw-600 fs-14 lh-20 brand-800'>{{dateObj.year}}</div>
                        <button :class="['btn-arrow',btnArrowClass,{'pointer-none disable': canNext}]" :disabled="canNext" aria-label="Next year" @click="nextYear">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                            <g clip-path="url(#clip0_1983_11740)">
                              <path d="M5.25 2.625L9.625 7L5.25 11.375" stroke="#0A0A0A" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                          </svg>
                        </button>
                      </div>
                      <div class="grid grid-gap-1 grid-template-columns-minmax3 pt-16 pb-6">
                        <button v-for='(item, index) in dateObj.month' :key='index'
                                class='button px-8 fw-400 ttu gray-950'
                                :class="{'is-selected': (index === dateObj.monthSelected.index),
                                         'pointer-none btn-month-disable' : (index <= pastMonth)}"
                                @click="selectMonth(item, index)">
                          {{item}}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="error-message" v-if="errorsMonth">This is a required field.</div>
                <div class='gray-700-brand fs-14 fw-500 lh-20 mt-8'>
                  Providing us with your travel schedule enables us to find the most competitive prices and determine the optimal options for your trip.
                </div>
              </template>
            </div>
            <div v-if="error" class='pb-30 red error-bottom'>{{ error }}</div>
          </div>
        </div>
      </div>
    </div>
    <FooterSteps :disableSubmitButton='disableSubmitButton'
                 :labelClass='formData.labelClass'
                 :stepActive='EnquiryStepEnum.YourTrip'
                 :isUIPopup='formData.isUIPopup'
                 :button-id="`enquiry-form-button-continue-step${indexCurrentStep}`"
                 @nextStep="nextStep"
                 @prevStep="$emit('prevStep')"/>
  </div>
</template>

<style lang="scss">
  :root {
    --vc-font-family: #{$font-family-base};
    --vc-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.08);
    --vc-border: #E6E6E6;

    // Q1/H3 (Wave 6) — was a mint-pastel ramp (#F3FFF3…#3E9377) off the v2 palette; rebuilt as
    // $brand-green tints so the live date picker's highlight/range/selected states read on-brand.
    .vc-blue {
      --vc-accent-50: #{mix($white, $brand-green, 92%)};
      --vc-accent-100: #{mix($white, $brand-green, 86%)};
      --vc-accent-200: #{mix($white, $brand-green, 76%)};
      --vc-accent-300: #{mix($white, $brand-green, 64%)};
      --vc-accent-400: #{mix($white, $brand-green, 50%)};
      --vc-accent-500: #{mix($white, $brand-green, 36%)};
      --vc-accent-600: #{mix($white, $brand-green, 22%)};
      --vc-accent-700: #{mix($white, $brand-green, 10%)};
      --vc-accent-800: #{$green-deep};
      --vc-accent-900: #{$brand-green};
    }

    .vc-light {
      /* Base */
      // M6 (Wave 6) — was `none`, killing the keyboard focus ring on day cells; restore a green
      // ring (box-shadow, so it survives the calendar's outline:none) per v2 Accessibility L578.
      --vc-focus-ring: 0 0 0 2px #{rgba($brand-green, 0.6)};

      /* Calendar header */
      --vc-header-title-color: #{$brand-green};

      /* Calendar nav */
      --vc-nav-item-active-bg: var(--vc-accent-900);
      --vc-nav-item-active-box-shadow: none;
      --vc-nav-item-current-color: var(--vc-accent-900);

      &.vc-attr,
      & .vc-attr {
        --vc-content-color: var(--vc-accent-600);
        --vc-highlight-outline-bg: var(--vc-white);
        --vc-highlight-outline-border: var(--vc-accent-600);
        --vc-highlight-outline-content-color: var(--vc-accent-700);
        --vc-highlight-light-bg: var(--vc-accent-200);
        --vc-highlight-light-content-color: var(--vc-accent-900);
        --vc-highlight-solid-bg: var(--vc-accent-900);
        --vc-highlight-solid-content-color: var(--vc-white);
        --vc-dot-bg: var(--vc-accent-600);
        --vc-bar-bg: var(--vc-accent-600);
      }
    }
    .vc-highlight-bg-solid {
      border-radius: 6px;
    }
    .vc-header .vc-arrow {
      background-color: #F5F5F5;
    }
  }
</style>

<style lang='scss' scoped>
  .month-year-popup {
    border: 1px solid brandColor(gray,200);
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.08);
    .btn-arrow.disable {opacity: .25}
    .button {
      min-height: 25px;
      height: 25px;
      border-radius: 6px;
      &.is-selected {background: $brand-green; color: white} // selected month — v2 brand green (was off-brand button-brand-800 fill)
      &.btn-month-disable {
        //background-color: brandColor(gray,200);
        color:  brandColor(gray,500);
      }
    }
  }
</style>
